// Store configuration — edit these with real details anytime.
export const STORE = {
  name_en: "Uttam Traders",
  name_mr: "उत्तम ट्रेडर्स",
  tagline_en: "Vairag's Trusted Destination",
  tagline_mr: "वैरागकरांच विश्वसनीय ठिकाण",
  phone: "+918788068480",
  phoneDisplay: "+91 87880 68480",
  whatsapp: "918788068480",
  address_en: "Madha Road, Near Santhnath Multispeciality Hospital, Vairag, Tal. Barshi, Dist. Solapur, Maharashtra 413402",
  address_mr: "माढा रोड, संतनाथ मल्टीस्पेशालिटी हॉस्पिटलजवळ, वैराग, ता. बार्शी, जि. सोलापूर, महाराष्ट्र ४१३४०२",
  hours_en: "Open Daily: 9:00 AM – 7:00 PM",
  hours_mr: "दररोज: सकाळी ९:०० – सायंकाळी ७:००",
  mapEmbed: "https://www.google.com/maps?q=Cera+Authorized+Dealer+Uttam+Traders,+Vairag&ll=18.0593211,75.7956718&z=17&output=embed",
  mapLink: "https://maps.app.goo.gl/kLbX1ziNAofMvVbJ6",
  established: "2004",
  email: "uttamtraders21@gmail.com",
  instagram: "https://www.instagram.com/uttam_traders_14/",
};

export const waLink = (msg) =>
  `https://wa.me/${STORE.whatsapp}?text=${encodeURIComponent(msg || "Hello, I would like to enquire about your products.")}`;
export const telLink = () => `tel:${STORE.phone}`;
